<template>
<div class="left side-menu">
    <img src="/icon-left.png" width="24" height="24" @click="$emit('hideMenu')" class="menu-collapse-btn" />
    <div class="sidebar-inner">
        <div id="sidebar-menu" class="menu-container">
            <ul id="menu-infos">
                <li class="warehouse-select mx-4 my-4 py-3 border-bottom">
                    <h5 class="row py-2">
                        <span class="col-5">{{ $t("user_manage.user") }}</span>
                        <span class="col-6"><strong>{{ userInfo.username }}</strong></span>
                    </h5>
                    <h5 class="row">
                        <span class="col-5">{{ $t("user_manage.tenant") }}</span>
                        <span class="col-6"><strong>{{ userInfo.tenantId }}</strong></span>
                    </h5>
                </li>
                <li class="warehouse-select mx-4 my-2 py-2">
                    <h6>{{ $t("user_manage.map") }}</h6>
                    <b-form-select :disabled="disabled" v-model="selected" :options="options" class="mb-3" size="sm" v-on:change="changeWarehouse" />
                </li>
            </ul>

            <ul id="menu-list">
                <!-- for each display -->
                <li v-bind:key="menu.id" v-for="menu in menus">
                    <RouterLink :to="getMenuLink(menu)" class="waves-effect waves-primary">
                        <i v-if="menu.icon && menu.icon !== '0'" v-bind:class="$t(`function_id.${menu.functionId}.${menu.icon}.logo_class`)"></i>
                        <i v-else v-bind:class="$t(`function_id.${menu.functionId}.logo_class`)"></i>
                        <span> {{ menu.name }} </span>
                    </RouterLink>
                </li>
            </ul>
        </div>
    </div>
</div>
</template>

<script>
// import Utils from "../utils/Utils";
import * as queries from "../../graphql/locus_queries";
import global from "../../Global.vue";
import AwsApi from "../../Api"
import { Auth } from 'aws-amplify';

export default {
    data: function () {
        return {
            selected: null,
            options: [],
            userInfo: {
                username: "",
                tenantId: ""
            },
            menus: [],
            warehouse_id: null,
            disabled: false
        };
    },
    mounted() {

        if (this.$route.meta.withoutDefaultWarehouse) {
            this.disabled = true
        }
        //         // set the page to the current warehouse from the url.
        this.setSelected();
        this.fetchUserInfo();
        this.fetchWarehouse();
        this.fetchMenuSettings();
        //         //listen event if menuSettings are updated
        this.$bus.on('patchMenuSettings', () => {
            this.fetchMenuSettings()
        })
        this.$bus.on('fetchWarehouse', () => {
            this.fetchWarehouse()
        })
    },
    watch: {
        // set the page to the current warehouse when switching history.
        $route(to, from) {
            // react to route changes...
            if (to.matched.some(record => record.meta.withoutDefaultWarehouse)) {
                this.disabled = true
                this.selected = null
            } else {
                this.disabled = false
                this.selected = this.$route.query.warehouse
            }
        },
    },
    methods: {
        getMenuLink(menu) {

            if (menu.functionId === global.functionIdMASTER) {
                return `/${menu.functionId}/${menu.id}/0?warehouse=${this.warehouse_id}`;
            }
            if (menu.functionId === global.functionIdSETTINGS) {
                return `/${menu.functionId}/${menu.id}`;
            }
            if (menu.functionId === global.functionIdCUSTOMERMASTER) {
                return `/${menu.functionId}/${menu.id}`;
            }
            if (menu.functionId === global.functionIdUSERMANAGE) {
                return `/${global.functionIdUSERMANAGE}`
            }
            return `/${menu.functionId}/${menu.id}?warehouse=${this.warehouse_id}`;
        },
        fetchUserInfo() {
            this.userInfo.username = sessionStorage.getItem(global.userName);
            this.userInfo.tenantId = sessionStorage.getItem(global.tenantId);
        },
        async fetchWarehouse() {
            this.options = []
            await this.listWarehouses()
            const userAuthManage = await this.getUserAuthManage() 
            if(userAuthManage === null || userAuthManage.mapId === null) {
            } else {
                this.options = this.options.filter(item=> userAuthManage.mapId.includes(item.value))
                if (userAuthManage.mapId.includes(-1)) {
                    this.options.unshift({
                        text: this.$t("all"),
                        value: -1
                    })
                }
            }

           
            if (this.options === undefined || this.options.length === 0) {
                this.warehouse_id = 0;
            } else {
                this.warehouse_id = this.options[0].value
            }
            this.changeWarehouse(this.warehouse_id);

        },
        async listWarehouses(nextTokenValue) {
            const response = await AwsApi.graphql({
                query: queries.listWarehouses,
                variables: {
                    tenantId: this.userInfo.tenantId,
                    nextToken: nextTokenValue

                }
            }, this);
            if (response === undefined) {
                return
            }
            this.options = this.options.concat(response.data.listWarehouses.items.map((item) => {
                 const option = {
                    value: item.id,
                    text: `${item.name}`,
                }
                return option
            }));
            if (response.data.listWarehouses.nextToken !== null) {
                await this.listWarehouses(response.data.listWarehouses.nextToken)
            }
        },
        async fetchMenuSettings() {

            const response = await AwsApi.graphql({
                query: queries.listMenus,
                variables: {
                    tenantId: this.userInfo.tenantId
                }
            }, this);
            if (response === undefined) {
                return
            }
            const tempMenus = response.data.listMenus.items.filter(item => {
                return item.showSide == null || item.showSide != global.showAPP
            }).sort(function (a, b) {
                return a.showOrder - b.showOrder
            });
            // UserManage
            if (this.userInfo.username.toLowerCase() === this.userInfo.tenantId.toLowerCase()) {
                this.menus = tempMenus
            } else {
                await this.getFunctionIdOption(tempMenus)
            }
        },
        async getFunctionIdOption(tempMenus) {
            const userAuthManage = await this.getUserAuthManage() 
           
            if(userAuthManage === null || userAuthManage.menuId === null) {
                this.menus = []
                return
            } else {
                this.menus = tempMenus.filter(item => userAuthManage.menuId.filter(j => j === item.id).length > 0)

            }

        },

        setSelected() {
            if (this.$route.query.warehouse !== undefined) {
                this.selected = this.$route.query.warehouse
            }
        },
        changeWarehouse(value) {
            this.warehouse_id = value;
            if (!this.disabled) {
                this.$router.push(`${this.$route.path}?warehouse=${value}`).catch(error => error);
            }
        },
        async getUserAuthManage(){
            const response = await AwsApi.graphql({
                query: queries.getUserAuthManage,
                variables: {
                    tenantId: this.userInfo.tenantId,
                    username: this.userInfo.username,
                }
            }, this);
            var getUserAuthManage = null
            if (response !== undefined && response.data.getUserAuthManage !== null) {
                getUserAuthManage = response.data.getUserAuthManage
            }
            return getUserAuthManage
        },
    },
};
</script>

<style scoped>
.warehouse-select {
    padding: 12px 20px;
}

.menu-collapse-btn {
    float: right;
}

.sidebar-inner {
    height: calc(100vh - 70px);
    overflow: hidden;
}

.menu-container {
    height: 100%;
    display: flex;
    flex-direction: column;
}

#menu-infos {
    flex-shrink: 0;
}

#menu-list {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
}
</style>
